(function() {
    'use strict';

    angular.module('allegro').controller(
        'AllegroCategorySelectModalController', AllegroCategorySelectModalController);

    AllegroCategorySelectModalController.$inject = ['$uibModalInstance', 'dataObj', 'allegroAccountDataSrvc'];

    function AllegroCategorySelectModalController($uibModalInstance, data, allegroAccountDataSrvc) {
        var self = this;

        self.loading = false;
        self.data = data;
        self.matchingCategoryOpts = [];
        self.categoryOpts = [];

        console.log("Data: ", data)

        self.getCategories = getCategories;
        self.getMatchingCategories = getMatchingCategories;
        self.onCategorySelect = onCategorySelect;
        self.onMatchingCategorySelect = onMatchingCategorySelect;
        self.categoryGoBack = categoryGoBack;
        self.isSelectedCategory = isSelectedCategory;
        self.modalClose = modalClose;

        activate();

        function activate() {
            initCategories();
            initMatchingCategories();
        }

        function initCategories(){
            var category = null;

            category = self.data.breadcrumbCategories.at(-1)
            if (category && self.isSelectedCategory(category)) {
                category = self.data.breadcrumbCategories.at(-2)
            }

            if (category) {
                self.getCategories(category.id);
            } else {
                self.getCategories();
            }
        }

        function initMatchingCategories(){
             if(self.data.categoryNameForSearch){
                self.getMatchingCategories(self.data.categoryNameForSearch);
            }
        }

        function getCategories(parentId){
            allegroAccountDataSrvc.getCategories({
                pk: self.data.accountId,
                parent_id: parentId
            }).$promise.then(function(response) {
                    self.categoryOpts = response.categories;
                    return response;
                },
                function(response) {}
            );
        }

        function getMatchingCategories(categoryName){
            allegroAccountDataSrvc.getMatchingCategories({
                pk: self.data.accountId,
                category_name: categoryName
            }).$promise.then(function(response) {
                    self.matchingCategoryOpts = response.matchingCategories;
                    return response;
                },
                function(response) {}
            );
        }

        function onCategorySelect(category){
            self.data.breadcrumbCategories.push(category)
            if(category.leaf){
                self.data.category = category;
                $uibModalInstance.close(self.data);
            } else {
                self.getCategories(category.id)
            }
        }

        function onMatchingCategorySelect(data){
            self.data.category = self.matchingCategoryOpts.find(
                function(obj){
                   return obj.id === data.category.id;
            })
            self.data.breadcrumbCategories = createCategoryBreadcrumb(self.data.category).reverse();
            $uibModalInstance.close(self.data);
        }

        function modalClose() {
            $uibModalInstance.dismiss('cancel');
        }

        function createCategoryBreadcrumb(category){
            var breadcrumbs = [category];
            for (var key in category) {
                if (key === 'parent' && category[key] !== null){
                    breadcrumbs = breadcrumbs.concat(createCategoryBreadcrumb(category[key]))
                }
            }
            return breadcrumbs
        }

        function categoryGoBack(){
            var category = null;
            self.data.breadcrumbCategories.pop()
            category = self.data.breadcrumbCategories.at(-1)
            if (category) {
                self.getCategories(category.id);
            } else {
                self.getCategories();
            }
        }

        function isSelectedCategory(category){
            return self.data.category && self.data.category.id === category.id;
        }
    }
})();
